module.exports = __webpack_public_path__ + "static/media/MgmtQuestions_IPOIntelligence_base.2d2b7e11.png";